export default __webpack_public_path__ + "assets/compass.svg?23ec53bf818c983fa752dffcd195f92a";